import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from '../Context/AuthUser';

const ProtectedRoute = () => {
  const { user, loading } = useAuth(); // loading while checking auth

  if (loading) {
    return <p>Loading...</p>; // or spinner
  }

  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
